import React from 'react';
import styles from './Dropdown.m.sass';

import cx from 'classnames';

export default class Dropdown extends React.PureComponent {
  static Item = ({children}) => children;

  constructor(props) {
    super(props);

    this.state = {isOpen: false};
  }

  _hide = () => this.setState({isOpen: false});

  componentDidUpdate() {
    if (this.state.isOpen && !this.props.mobile) {
      setTimeout(() => {
        window.addEventListener('click', this._hide);
      }, 1);
    } else {
      window.removeEventListener('click', this._hide);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this._hide);
  }

  render() {
    const {isOpen} = this.state;
    const {mobile, children, onChange, value} = this.props;

    const childrenArray = React.Children.toArray(children);
    const activeItem = childrenArray.find(({props}) => props.value === value);
    const otherChildren = childrenArray.filter(it => it !== activeItem);

    if (!mobile) {
      return (
        <div
          className={cx(styles.dropdown, isOpen && styles.dropdown__active)}
          onClick={() => this.setState({isOpen: !isOpen})}
        >
          <div className={styles.dropdown_wrapper}>
            <div className={styles.dropdown_gradientWrapper}>
              <button className={styles.dropdown_trigger}>{activeItem.props.children}</button>
              <div className={styles.dropdown_content}>
                <div className={styles.dropdown_item}>{activeItem.props.children}</div>
                {otherChildren.map(({props}) => (
                  <div
                    key={props.value}
                    className={styles.dropdown_item}
                    onClick={() => onChange(props.value)}
                  >
                    {props.children}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className={styles.dropdown_selectWrapper}>
        <select
          className={styles.dropdown_select}
          value={value}
          onChange={e => onChange(e.target.value)}
        >
          {childrenArray.map(({props}) => (
            <option
              key={props.value}
              value={props.value}
            >
              {props.children}
            </option>
          ))}
        </select>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/dropdown/Dropdown.js